import React, { useReducer, useEffect } from "react";
import { Table, Row, Col, Button, Alert } from "react-bootstrap";
import ModuleDisplayEmail from "../modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../modules/fieldsDisplay/ModuleDisplayPhone";
import axios from "../../../config/axios";
import moduleConfig from "../../modules/testimonial/moduleConfig";
import {
  listingInitialState,
  listingReducer,
} from "../../../reducers/module/listingReducer";
import { Link } from "react-router-dom";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import { getFullName } from "../../../helpers/CommonHelper";
import ModuleDisplayBoolean from "../modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDate from "../modules/fieldsDisplay/ModuleDisplayDate";
function TestimonialContent({ setParent, parent }) {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );
  const loadItems = async () => {
    listingDispatch({
      type: "FETCH_REQUEST",
    });
    setParent(true);
    try {
      const res = await axios.get(`${moduleConfig.url}?limit=10`);
      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
      setParent(false);
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
      setParent(false);
    }
  };
  useEffect(() => {
    loadItems();
  }, []);

  return (
    <>
      {listingState.hasFetchingError && (
        <Alert variant="warning mb-0 mt-1">
          OOPS!!! Something went wrong, please try again later.
        </Alert>
      )}
      <Row className="mt-2 mb-3">
        {listingState.data.items && listingState.data.items.length > 0 && (
          <Col>
            <h5 className="  text-bold">Recent Testimonials</h5>
          </Col>
        )}
        {listingState.data.items && listingState.data.items.length > 0 && (
          <Col>
            <Button
              title="Please click to view all submissions"
              variant="primary"
              className="float-end"
              href="/testimonials"
              size="sm"
            >
              View all
            </Button>
          </Col>
        )}
      </Row>

      {listingState.data.items && listingState.data.items.length <= 0 && (
        <Alert variant="warning mb-0 mt-1">No records found.</Alert>
      )}
      {listingState.data.items && listingState.data.items.length > 0 && (
        <>
          <Row>
            <Col className="overflow-auto">
              <Table striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Full Name</th>

                    <th>Email</th>
                    <th>Company</th>
                    <th>Designation</th>
                    <th>Submission Date</th>
                    <th>Show on Home Page</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {listingState.data &&
                    listingState.data.items &&
                    listingState.data.items.length &&
                    listingState.data.items.map((item, itemIndex) => {
                      return (
                        <tr key={itemIndex}>
                          <td>{itemIndex + 1}</td>
                          <td>{getFullName(item)}</td>

                          <td>
                            <ModuleDisplayEmail value={item.email} />
                          </td>
                          <td>{item.company}</td>
                          <td>{item.designation}</td>
                          <td>
                            <ModuleDisplayDate value={item.createdAt} />
                          </td>
                          <td>
                            <ModuleDisplayBoolean
                              value={item.showOnHomePage}
                              trueColor="pink"
                              falseColor="dark"
                            />
                          </td>
                          <td>
                            <ModuleDisplayBoolean
                              value={item.status}
                              trueValue="Enabled"
                              falseValue="Disabled"
                            />
                          </td>
                          <td
                            className={`text-center record-actions  MoreItem`}
                          >
                            <Link
                              title="Please click to view details"
                              to={`/testimonials/${item._id}`}
                              className="btn btn-outline-secondary btn-sm"
                            >
                              <i className="fas fa-eye"></i>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default TestimonialContent;
